import { useState } from "react";
import { motion } from "framer-motion";
import { PLATFORMS } from "@/data/platforms";
import { t } from "@/lib/strings";

const PlatformLogo = ({ p }) => {
  const [hover, setHover] = useState(false);
  const Icon = p.Icon;
  return (
    <motion.div
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      whileHover={{ scale: 1.12, rotateY: 12, z: 20 }}
      transition={{ type: "spring", stiffness: 300, damping: 18 }}
      style={{ transformPerspective: 600 }}
      className="flex items-center gap-2 cursor-default select-none"
      data-testid={`platform-logo-${p.name.split(" ")[0].toLowerCase()}`}
    >
      <Icon
        style={{ fontSize: 26, color: hover ? p.color : "#8a8a8a", transition: "color 0.25s", filter: hover ? `drop-shadow(0 0 10px ${p.color}88)` : "none" }}
      />
      <span className="font-heading font-bold text-base whitespace-nowrap" style={{ color: hover ? "#fff" : "#8a8a8a", transition: "color 0.25s" }}>
        {p.short || p.name}
      </span>
    </motion.div>
  );
};

export const TrustStrip = () => (
  <section className="bg-obsidian text-white py-8 border-b-2 border-obsidian overflow-hidden">
    <div className="av-container">
      <p className="text-center font-data text-[11px] uppercase tracking-[0.28em] text-neutral-500 mb-6">
        {t("trust.title")}
      </p>
      <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-5 md:gap-x-12">
        {PLATFORMS.map((p) => <PlatformLogo key={p.name} p={p} />)}
      </div>
    </div>
  </section>
);

export default TrustStrip;
